import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = 'articles/typeahead/search';

export class ArticlesTypeaheadService extends BaseService {
    async suggest(query: string, limit: number = 8): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(URL, { params: { query, limit } }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}
